<template>
  <div class="full-address">

    <div
      class="input-wrap"
      :class="{ valid: validinputs }"
    >
      <label for="signup-details__address__line-one__text-input">Delivery street address</label>
      <input
        type="text"
        name="delivery_address_1"
        :value="street">
    </div>

    <div
      class="input-wrap"
    >
      <label for="signup-details__address__line-two__text-input">Line 2
        <span class="hint">(optional)</span>
      </label>
      <input
        type="text"
        name="delivery_address_2">
    </div>

    <div
      class="input-wrap"
      :class="{ valid: validinputs }"
    >
      <label for="signup-details__address__town__text-input">Town</label>
      <input
        type="text"
        name="delivery_address_town"
        :value="town">
    </div>

    <div
      class="input-wrap"
      :class="{ valid: validinputs }"
    >
      <label for="signup-details__address__country__dropdown">Country</label>
      <select name="delivery_address_country">
        <!-- <option disabled="disabled" hidden="hidden" value=""></option> -->
        <option value="United Kingdom">United Kingdom</option>
        <option value="Republic or Ireland">Republic or Ireland</option>
        <option value="France">France</option>
        <option value="Italy">Italy</option>
        <option value="Germany">Germany</option>
      </select>
    </div>

    <div
      class="input-wrap postcode"
      :class="{ valid: validinputs }"
    >
      <label for="signup-details__address__postcode__text-input">Postcode</label>
      <input
        type="text"
        name="delivery_address_postal_code"
        :value="postcode">
    </div>

  </div>
</template>

<script>
export default {
  props: {
    street: {
      type: String,
      default: '1 Street-name'
    },
    town: {
      type: String,
      default: 'Town-name'
    },
    country: {
      type: String,
      default: 'United Kingdom'
    },
    postcode: {
      type: String,
      default: 'A1 11A'
    },
    validinputs: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/library/full-address.vue